import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-12 p-lg-12"
}
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_4 = {
  key: 0,
  id: "fullname-note",
  class: "p-error"
}
const _hoisted_5 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_6 = {
  key: 0,
  id: "year-note1",
  class: "p-error"
}
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_8 = {
  key: 0,
  id: "phone-note1",
  class: "p-error",
  style: {"text-align":"left"}
}
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_10 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_11 = {
  key: 0,
  id: "id-note1",
  class: "p-error"
}
const _hoisted_12 = { class: "p-field p-col-12 p-sm p-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Đặt lịch khám" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          ($setup.follow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[8] || (_cache[8] = _createElementVNode("label", null, "Vui lòng quan tâm ZaloOA của Trung tâm Y tế Hòa Vang và cung cấp thông tin để hoàn thành đăng ký khám bệnh.", -1)),
                _createVNode(_component_Button, {
                  severity: "warning",
                  label: "Mở ZaloOA",
                  icon: "pi pi-external-link",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openLink()))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Họ và tên", -1)),
            _createVNode(_component_InputText, {
              id: "fullname",
              type: "text",
              modelValue: $setup.register.customerName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.register.customerName) = $event)),
              style: {"text-align":"left"}
            }, null, 8, ["modelValue"]),
            (!$setup.register.customerName)
              ? (_openBlock(), _createElementBlock("small", _hoisted_4, "* Vui lòng cung cấp họ và tên"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "year" }, "Chọn năm sinh:", -1)),
            _createVNode(_component_Calendar, {
              id: "year",
              modelValue: $setup.register.year,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.register.year) = $event)),
              view: "year",
              dateFormat: "yy",
              manualInput: true
            }, null, 8, ["modelValue"]),
            (!$setup.register.year)
              ? (_openBlock(), _createElementBlock("small", _hoisted_6, "* Vui lòng chọn năm sinh"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Số điện thoại", -1)),
            _createVNode(_component_InputText, {
              id: "phoneNumber",
              type: "text",
              modelValue: $setup.register.phoneNumber,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.register.phoneNumber) = $event)),
              style: {"text-align":"left"}
            }, null, 8, ["modelValue"]),
            (!$setup.register.phoneNumber)
              ? (_openBlock(), _createElementBlock("small", _hoisted_8, "* Vui lòng cung cấp số điện thoại"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[12] || (_cache[12] = _createElementVNode("label", null, "Yêu cầu khám của bạn(không bắt buộc)", -1)),
            _createVNode(_component_InputText, {
              id: "message",
              type: "text",
              modelValue: $setup.register.message,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.register.message) = $event)),
              style: {"text-align":"left"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "dateBooking" }, "Chọn ngày khám:", -1)),
            _createVNode(_component_Calendar, {
              id: "dateBooking",
              modelValue: $setup.register.timeBooking,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.register.timeBooking) = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              minDate: $setup.minDate,
              yearRange: "1900:2050"
            }, null, 8, ["modelValue", "minDate"]),
            (!$setup.register.timeBooking)
              ? (_openBlock(), _createElementBlock("small", _hoisted_11, "* Vui lòng chọn ngày đặt lịch khám"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Chọn giờ khám", -1)),
            _createVNode(_component_Dropdown, {
              id: "hourselect",
              modelValue: $setup.register.hour,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.register.hour) = $event)),
              options: $setup.gioDatLich,
              optionLabel: "value",
              optionValue: "value",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_Button, {
          label: "Đặt lịch",
          icon: "pi pi-plus-circle",
          disabled: !$setup.valid(),
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.addRegister())),
          style: {"margin-right":"20px"}
        }, null, 8, ["disabled"])
      ]),
      _: 1
    })
  ], 64))
}